import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PrefixService} from 'app/services/prefix.service';

const CLOSE_RESULT = 'Close click';

@Component({
  selector: 'app-edit-standard-number',
  templateUrl: './edit-standard-number.component.html',
  styleUrls: ['./edit-standard-number.component.css']
})
export class EditStandardNumberComponent implements OnInit {

  stnNumber: string;
  newNumber: string;

  constructor(public activeModal: NgbActiveModal,
              private prefixService: PrefixService) {
  }

  ngOnInit() {
  }

  setCurrentNumber(number) {
    this.stnNumber = number;
    this.newNumber = number;
  }

  editNumber() {
    if (!this.prefixService.getSelectedPrefix()) { return; }
    this.prefixService.customStndNumber = this.prefixService.getNumberPrefix() + this.newNumber;
    this.stnNumber = this.newNumber;
    this.activeModal.close(CLOSE_RESULT);
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard/modal/edit-standard-number/edit-standard-number.component.ts